import { Component, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Tiger Zen Do | Centro de Artes Marciales';
  showFooter = true;
  scrollPercent: number = 0;

  constructor(
    private router: Router,
    private titleService: Title,
    private metaService: Meta
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/error' || event.url === '/coming-soon') {
          this.showFooter = false;
          this.titleService.setTitle('Error / Coming Soon | Tiger Zen Do');
          this.updateMetaTags('Página no encontrada o en mantenimiento', 'error, coming soon, Tiger Zen Do');
        } else {
          this.showFooter = true;
          this.titleService.setTitle('Bienvenido a Tiger Zen Do | Tu Portal de Entrenamiento');
          this.updateMetaTags(
            'Tiger Zen Do: Artes Marciales, Entrenamientos y Bienestar',
            'entrenamiento, artes marciales, bienestar, Tiger Zen Do'
          );
        }
      }
    });
  }

  @HostListener('window:scroll', [])
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    this.scrollPercent = Math.round((scrollTop / scrollHeight) * 100);
  }

  private updateMetaTags(description: string, keywords: string) {
    this.metaService.updateTag({ name: 'description', content: description });
    this.metaService.updateTag({ name: 'keywords', content: keywords });
    this.metaService.updateTag({ name: 'author', content: 'Tiger Zen Do Team' });
    this.metaService.updateTag({ property: 'og:title', content: this.title });
    this.metaService.updateTag({ property: 'og:description', content: description });
    this.metaService.updateTag({ property: 'og:image', content: 'https://www.tigerzendo.com/assets/og-image.jpg' });
    this.metaService.updateTag({ property: 'og:url', content: 'https://www.tigerzendo.com' });
  }
}
